import { HttpErrorResponse } from '@angular/common/http';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {SessionModel} from '../../models/session.model';
import {Base64Service} from '../../utils/base64.service';
import moment from 'moment';
import {ResizeEvent} from 'angular-resizable-element';
import {exportPDF, Group} from '@progress/kendo-drawing';
import {GoogleAddressModel} from '@coremodels';
import {AlertService} from '..';
import {Constants} from '../../constants';
import {isPlatformBrowser} from '@angular/common';
import {extractErrorMessage} from '../../utils/error-message.util';


@Injectable({
    providedIn: 'root'
})
export class HelperService {

    constructor(
        private notificationService: AlertService,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
    }

    parseFloat(value: any): any {
        if (!isNaN(value)) {
            parseFloat(value);
        } else {
            return 0.0;
        }
    }

    parseInt(value: any): any {
        if (!isNaN(value)) {
            parseInt(value);
        } else {
            return 0;
        }
    }

    isNumber(value: any) {
        return !isNaN(value);
    }

    //#region Error Handeling
    handleError(error: HttpErrorResponse) {
        // 422 responses never reach the global ErrorInterceptor toast (they are
        // propagated to the component), so the backend message has to be shown
        // from here or the failure is completely silent.
        this.notificationService.error(extractErrorMessage(error));
    }

    handleMultipleErrors(error: HttpErrorResponse) {
        if (error.status === 422 && Array.isArray(error?.error?.data)) {
            for (const item of error.error.data) {
                if (item?.message) {
                    this.notificationService.error(item.message);
                }
            }
        } else {
            this.notificationService.error(extractErrorMessage(error));
        }
    }

    scrollIntoView(idOfElement: string) {
        if (idOfElement !== null) {

            document.getElementById(idOfElement)!.scrollIntoView({
                behavior: 'smooth'
            });

        }
    }

    //#region general functions
    removeProprtyFromList(list: any) {
        list = list.filter(function (props?: any) {
            if (props.searchValue) {
                delete props.searchValue;
            }

            return true;
        });
    }


    //#endregion

    //#endregion

    /**
     *
     * @param date
     */
    formatDate(date: string) {
        return (date != null || date != '' || date != undefined) ? moment(date).format('DD-MM-YYYY') : '';
    }

    resizeColumn(event: ResizeEvent, columnName: any) {
        if (event.edges.right) {
            const rowWidth = document.getElementsByClassName('header_row');
            const parentWidth = rowWidth[0].clientWidth;
            const childWidth = event.rectangle.width;
            const columnElts = document.getElementsByClassName('header_column_' + columnName);
            for (let i = 0; i < columnElts.length; i++) {
                const currentEl = columnElts[i] as HTMLDivElement;
                currentEl.style.width = childWidth + 'px';
            }
        }
    }

    /**
     * Export PDF
     */
    // public export(pdfComponent: any, fileName: any): void {
    //     pdfComponent.export().then((group: Group) => exportPDF(group)).then((dataUri?: any) => {
    //         const base64 = dataUri.replace('data:application/pdf;base64,', '');
    //         const fileObject = this.dataURLtoFile(dataUri, fileName);
    //         const file = new Blob([fileObject], {type: 'application/pdf'});
    //         if (isPlatformBrowser(this.platformId)) {
    //             const fileURL = window.URL.createObjectURL(fileObject);
    //             if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //                 window.navigator.msSaveOrOpenBlob(file, fileName);
    //             } else {
    //                 const blobURL = URL.createObjectURL(file);
    //                 window.open(blobURL);
    //             }
    //         }
    //     });
    // }
    public export(pdfComponent: any, fileName: any): void {
        pdfComponent.export().then((group: Group) => exportPDF(group)).then((dataUri?: any) => {
            const base64 = dataUri.replace('data:application/pdf;base64,', '');
            const fileObject = this.dataURLtoFile(dataUri, fileName);
            const file = new Blob([fileObject], { type: 'application/pdf' });

            if (isPlatformBrowser(this.platformId)) {
                const blobURL = URL.createObjectURL(file);

                // Use a temporary anchor to trigger the download
                const a = document.createElement('a');
                a.href = blobURL;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                // Cleanup
                URL.revokeObjectURL(blobURL);
                document.body.removeChild(a);
            }
        });
    }


    public dataURLtoFile(dataurl?: any, filename?: any) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
    }


    /**
     * Common Function for the Google Address
     * @param address
     * @returns
     */
    public addressHandler(address) {
        if (!address?.formatted_address || !address?.address_components) {
            return null;
        }

        let addressModel = new GoogleAddressModel();
        let streetAddress = '';
        let isStreet = false;

        // Create a map to store components by type
        const componentMap = new Map();

        // First, organize all components by type
        address.address_components.forEach((component: any) => {
            if (component.types && component.types.length > 0) {
                component.types.forEach((type: string) => {
                    componentMap.set(type, component);
                });
            }
        });

        // Handle subpremise and street number first
        const subpremise = componentMap.get('subpremise');
        const streetNumber = componentMap.get('street_number');

        if (subpremise) {
            // Google writes the unit lowercase ('unit 2'): capitalise it like the rest of the address
            streetAddress += subpremise.long_name.replace(/^\w/, (c: string) => c.toUpperCase()) + '/';
        }

        if (streetNumber) {
            isStreet = true;
            streetAddress += streetNumber.long_name;
        }

        // Handle premise
        const premise = componentMap.get('premise');
        if (premise) {
            streetAddress += (streetAddress ? ',' : '') + ' ';
        }

        // Handle route (street name)
        const route = componentMap.get('route');
        if (route) {
            addressModel.address_line_1 = streetAddress
                ? `${streetAddress}, ${route.long_name}`
                : route.long_name;
        }

        // Map remaining components
        const mappings = {
            'sublocality_level_3': (comp: any) => addressModel.address_line_2 = comp.long_name,
            'postal_code': (comp: any) => addressModel.post_code = comp.long_name,
            'locality': (comp: any) => addressModel.suburb = comp.long_name,
            'administrative_area_level_1': (comp: any) => addressModel.state_region = comp.short_name,
            'administrative_area_level_2': (comp: any) => addressModel.city = comp.long_name,
            'country': (comp: any) => addressModel.country = comp.long_name
        };

        // Apply mappings
        Object.entries(mappings).forEach(([type, handler]) => {
            const component = componentMap.get(type);
            if (component) {
                handler(component);
            }
        });

        addressModel.isStreetAddress = isStreet;
        return addressModel;
    }

    /**
     * Maps a payment's mode/option to its display label, preserving the
     * online vs offline distinction (e.g. 'Offline(Credit Card)' vs 'Credit Card').
     * When the payment is online (payment_mode === 'ON') the payment_option drives
     * the label, otherwise the payment_mode does. Returns '—' when neither resolves.
     */
    public getPaymentMethodLabel(paymentMode: string, paymentOption?: string): string {
        const isOnline = paymentMode === 'ON';
        const method = isOnline ? paymentOption : paymentMode;
        switch (method) {
            case 'CC':
                return isOnline ? 'Credit Card' : 'Offline(Credit Card)';
            case 'BT':
                return 'Bank Transfer';
            case 'UN':
                return 'Offline(Unknown)';
            case 'IE':
                return 'Invoice Export';
            case 'BP':
                return 'BPAY';
            case 'PI':
                return 'PayID';
            case 'PT':
                return 'PayTo';
            case 'C':
                return isOnline ? 'Cash' : 'Offline(Cash)';
            default:
                return '-';
        }
    }

    public getErrorImage(event: any, image?: any) {
        if (image == "" || image == undefined) {
            event.target.src = Constants.NO_IMAGE_PRODUCT;
            // event.target.src = localStorage.getItem(
            //     'front_image_kit_url'
            // ) + '/' + environment.imageKitAssetFolder+'/no-image-product-small.svg?tr=w-30,h-30'
        } else {
            // event.target.src = Constants.S3_BUCKET_URL + '/' + image;
            event.target.src = Constants.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/WEBSITE_ASSET_STAGING' + '/' + image;
        }
    }
}
